import { string } from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { Banner } from 'components';
import { routes } from 'router';

const PurchaseConfirmation = ({ pageType }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onNextClick = () => {
    navigate(routes.home.path, { replace: true });
  };

  return (
    <>
      {pageType !== 'travelBalance' && (
        <Banner
          type="info"
          icon={{
            name: pageType === 'travel' ? 'umbrella-beach' : 'ferris-wheel',
            style: 'fad'
          }}
          className="mb-6"
        >
          <p>{t('purchase:confirmation.orderConfirmation')}</p>
        </Banner>
      )}

      <h2 className="underlined-blue h3 lg:h2">
        {pageType === 'travelBalance' ? t(`purchase:confirmation.${pageType}Title`) : t('purchase:confirmation.title')}
      </h2>

      <div className="pt-4 lg:pt-6">
        <Trans i18nKey={`purchase:confirmation.${pageType}Description`} className="text-gray-600 md:w-4/5">
          <br />
          <br />
          <br />
          <br />
          <Link to={routes.dashboard.children.orders.path} className="underline hover:no-underline text-primary-500">
            {t('dashboard')}
          </Link>
          <br />
          <br />
          <br />
          <br />
        </Trans>
      </div>
      <button type="button" className="btn my-4 max-md:w-full lg:mx-auto" onClick={onNextClick}>
        {t('buttons.goBackHome')}
      </button>
    </>
  );
};

PurchaseConfirmation.propTypes = {
  pageType: string.isRequired
};

export default PurchaseConfirmation;
